import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const getDepartments = async () => {
    try {
        let response = await ServiceRequest('get', 'json', serviceHost + '/master/departments');
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const getMastersByGroup = async (group) => {
    try {
        let response = await ServiceRequest('get', 'json', serviceHost + '/master/masters/' + group);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}
export const getAllMasters = async () => {
    try {
        let response = await ServiceRequest('get', 'json', serviceHost + '/master/mastersgrouped');
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}
